import { PermissionLevel } from "./withAccessHandler";
import { useAppSelector } from "lib/redux";
import { selectMe } from "domains/account";
import { usePack } from "lib/hooks";
import { useRouter } from "next/router";

const hasRequiredRole = (
  allowedRoles: PermissionLevel[],
  userRole: PermissionLevel | null,
  pack: any
): boolean => {
  if (!userRole) {
    return pack?.anon?.is_valid;
  }

  const findRole = allowedRoles.findIndex((role) => (
    role.toLocaleUpperCase() === userRole.toLocaleUpperCase()
  ));

  return findRole >= 0;
}

const withComponentAccessHandler = (allowedRoles: PermissionLevel[], options?: any) => (WrappedComponent) => {
  const AccessHandler = (props) => {
    const { query: { id }} = useRouter();
    const me = useAppSelector(selectMe);
    const { data: pack } = usePack(id as string);

    const hasAccess = hasRequiredRole(allowedRoles, me.permissions, options?.checkPack ? pack : null);

    return (
      hasAccess ? <WrappedComponent { ...props } /> : null
    )
  }
  AccessHandler.displayName = 'withComponentAccessHandler';
  return AccessHandler;
}

export default withComponentAccessHandler;
